import { render, staticRenderFns } from "./NossaHistoria.vue?vue&type=template&id=e897a004"
import script from "./NossaHistoria.vue?vue&type=script&lang=js"
export * from "./NossaHistoria.vue?vue&type=script&lang=js"
import style0 from "./NossaHistoria.vue?vue&type=style&index=0&id=e897a004&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports